import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import styled from 'styled-components';

import { Heading } from 'components/chroma';
import { InsuranceName } from 'scenes/common/types';
import { SCREEN } from 'scenes/common/types/screen';
import { INSURANCE_INFO } from 'scenes/common/helpers/insuranceInfo';

import InsuranceCard from './InsuranceCard';

const HeadingWrapper = styled.div`
  text-align: center;
`;

const DesktopContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 1rem;
`;

const MobileContainer = styled.div`
  display: block;
`;

export const InsuranceList: FunctionComponent<{
  insuranceName?: InsuranceName;
  paymentPortal?: boolean;
}> = ({ insuranceName, paymentPortal }) => {
  const headingContent = paymentPortal
    ? `Would you like to get a quote?`
    : `Would you like another quote?`;
  const headingSize = 3;
  return (
    <Media query={{ maxWidth: SCREEN.MEDIUM_LARGE }}>
      {(mobileScreen) =>
        mobileScreen ? (
          <>
            <HeadingWrapper>
              <Heading size={headingSize} margin={{ top: 9 }}>
                {headingContent}
              </Heading>
            </HeadingWrapper>
            <MobileContainer>
              {INSURANCE_INFO.filter(
                (insurance) => insurance.name !== insuranceName
              ).map((insurance) => (
                <InsuranceCard key={insurance.name} insurance={insurance} />
              ))}
            </MobileContainer>
          </>
        ) : (
          <>
            <HeadingWrapper>
              <Heading size={headingSize} margin={{ top: 9 }}>
                {headingContent}
              </Heading>
            </HeadingWrapper>
            <DesktopContainer>
              {INSURANCE_INFO.filter(
                (insurance) => insurance.name !== insuranceName
              ).map((insurance) => (
                <InsuranceCard key={insurance.name} insurance={insurance} />
              ))}
            </DesktopContainer>
          </>
        )
      }
    </Media>
  );
};

export default InsuranceList;
